import { type Level, LevelSchema } from './level';

export const vanillaSize = {
  width: 16,
  height: 27,
};

export const defaultLevel: Level = LevelSchema.parse({
  levelName: 'New Level',
  levelNumber: 0,
  levelPackNumber: 1,
  levelTheme: 0,
  levelPattern: 0,
  levelCamAngle: 73.44001007080078,
  levelMechanics: [
    {
      name: 'prWall',
      pos: [15.5, 0.5, 13.5],
      saveRot: false,
      rot: [1.0, 0.0, 0.0, 0.0],
      saveScale: false,
      scale: [1.0, 1.0, 27.0],
      saveAdditional: false,
      additional: [],
    },
    {
      name: 'prWall',
      pos: [0.5, 0.5, 13.5],
      saveRot: false,
      rot: [1.0, 0.0, 0.0, 0.0],
      saveScale: false,
      scale: [1.0, 1.0, 27.0],
      saveAdditional: false,
      additional: [],
    },
    {
      name: 'prWall',
      pos: [8.0, 0.5, 0.5],
      saveRot: false,
      rot: [1.0, 0.0, 0.0, 0.0],
      saveScale: false,
      scale: [14.0, 1.0, 1.0],
      saveAdditional: false,
      additional: [],
    },
    {
      name: 'prWall',
      pos: [8.0, 0.5, 26.5],
      saveRot: false,
      rot: [1.0, 0.0, 0.0, 0.0],
      saveScale: false,
      scale: [14.0, 1.0, 1.0],
      saveAdditional: false,
      additional: [],
    },
    {
      name: 'prHole',
      pos: [8.0, 0.0, 23.0],
      saveRot: false,
      rot: [1.0, 0.0, 0.0, 0.0],
      saveScale: false,
      scale: [1.0, 1.0, 1.0],
      saveAdditional: false,
      additional: [],
    },
    {
      name: 'prTee',
      pos: [8.0, 0.05000000074505806, 5.5],
      saveRot: false,
      rot: [0.7071068286895752, 0.7071068286895752, 0.0, 0.0],
      saveScale: false,
      scale: [2.9093751907348635, 2.078125, 1.0],
      saveAdditional: true,
      additional: [],
    },
    {
      name: 'prGround',
      pos: [8.0, -0.5, 13.5],
      saveRot: false,
      rot: [1.0, 0.0, 0.0, 0.0],
      saveScale: false,
      scale: [16.0, 1.0, 27.0],
      saveAdditional: false,
      additional: [],
    },
  ],
});
